<div class="wrap">
  <app-modal-generic-header
    [header]="'@components.barcodeManualInput.header' | translate"
    (closeClicked)="modalService.dismiss(false)"
  ></app-modal-generic-header>
  <div class="form">
    <app-input
      [control]="barcodeControl"
      [inputType]="'number'"
      [label]="'@components.barcodeManualInput.form.barcode.label' | translate"
      [placeholder]="
        '@components.barcodeManualInput.form.barcode.placeholder' | translate
      "
    ></app-input>
    <div
      *ngIf="barcodeControl.touched && barcodeControl.errors !== null"
      class="validation-message"
    >
      {{ "@components.barcodeManualInput.form.validationError" | translate }}
    </div>
  </div>
  <app-action-button
    [label]="'@components.barcodeManualInput.cta' | translate"
    (click)="onConfirmClick()"
    [disabled]="barcodeControl.invalid"
    class=""
  ></app-action-button>
</div>
